<template>
    <side-bar :title="title">
      <template slot-scope="props" slot="links">
        <sidebar-item
          v-for="item in availableMenuItems"
          :key="item.id"
          :link="{ name: item.title, icon: 'now-ui-icons ' + item.icon, path: item.path }"
        >
        </sidebar-item>
      </template>
    </side-bar>
</template>

<script>

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Menu',
  data () {
    return {
      links: [
        {
          id: 0,
          path: '/dashboard',
          title: 'Home',
          icon: 'business_chart-pie-36'
        },
        {
          id: 1,
          path: '/profile',
          title: 'Profile',
          icon: 'users_circle-08'
        },
        {
          id: 2,
          path: '/subscriptions',
          title: 'Subscriptions',
          icon: 'business_badge'
        },
        {
          id: 3,
          path: '/payments',
          title: 'Payments',
          icon: 'el-icon-wallet'
        },
        {
          id: 4,
          path: '/invoice',
          title: 'Documents',
          icon: 'files_paper'
        },
        {
          id: 5,
          path: '/contacts',
          title: 'Contacts',
          icon: 'ui-1_send'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      authorize: 'isAuthorize'
    }),
    ...mapState({
      title: state => state.config.data.title,
      menu: state => state.config.data.menu
    }),
    availableMenuItems() {
      return this.links.filter((link) => this.menu[link.path.replace(/^\/+/g, '')])
    }
  },
  watch: {
    '$route' () {
      this.$store.dispatch('changeStateMenu', false)
    }
  }
}

</script>
